import { DocumentEntity } from 'serviceWorker/repository/document/entity';
import { createInspectionScopedEntityPath } from 'shared/domain/document/inspectionDocumentUrlPaths';

export function createUrlFromInspectionDocument(
  document: DocumentEntity
): string {
  if (
    document.templateId ||
    document.protocolId ||
    document.sectionId
  ) {
    return createInspectionScopedEntityPath({
      inspectionId: document.inspectionId,
      templateId: document.templateId,
      checklistId: document.checklistId,
      sectionId: document.sectionId,
      protocolId: document.protocolId,
    });
  }

  return `/inspection/${document.inspectionId}`;
}
